import React from 'react';

function UsageIndicator({ usage, isAdmin, isPaid, onUpgrade, onLogin }) {
  if (isAdmin || isPaid) {
    return (
      <div className="usage-indicator admin">
        <span className="usage-icon">✓</span>
        <span>Unlimited Access</span>
      </div>
    );
  }

  if (!usage) return null;

  const lookups = usage.houseLookups?.limit - usage.houseLookups?.used || 0;
  const draws = usage.boundaryDraws?.limit - usage.boundaryDraws?.used || 0;
  const exports = usage.leadsExtracted?.limit - usage.leadsExtracted?.used || 0;
  const total = lookups + draws + exports;

  const isLow = total <= 3;
  const isDanger = total === 0;

  return (
    <div className="usage-wrapper">
      <div
        className={`usage-indicator ${isDanger ? 'danger' : isLow ? 'warning' : ''}`}
        onClick={isDanger ? onUpgrade : undefined}
        style={{ cursor: isDanger ? 'pointer' : 'default' }}
      >
        <span className="usage-icon">
          {isDanger ? '🔒' : isLow ? '⚠️' : '📊'}
        </span>
        <span className="usage-text">
          {isDanger ? (
            'Upgrade'
          ) : (
            <>
              <strong>{lookups}</strong> lookups · <strong>{draws}</strong> draws · <strong>{exports}</strong> exports
            </>
          )}
        </span>
      </div>
      <button className="login-link" onClick={onLogin} title="Admin Login">
        🔑
      </button>
    </div>
  );
}

export default UsageIndicator;
